import React, { useState } from "react";
import { Box, Typography, Tab } from "@mui/material/";
import { TabContext, TabList, TabPanel } from "@mui/lab/";
import DataCheck from "../AllAssets/DataCheck";
import { strings } from "../common/i18n";
import styles from "./styles";

export default () => {
    const [value, setValue] = useState("dataCheck");
    const handleChange = (event, newValue) => setValue(newValue);

    return (
        <Box>
            <Box sx={styles.mainHeaderContainer}>
                <Typography variant="h6" sx={styles.tabHeader}>
                    {strings("dataCheck")}
                </Typography>
            </Box>
            <TabContext value={value} sx={styles.tabContext}>
                <Box sx={styles.tabListContainer}>
                    <TabList onChange={handleChange}>
                        <Tab label={strings("dataCheck")} value="dataCheck" />
                    </TabList>
                </Box>
                <TabPanel value="dataCheck" sx={styles.tabPanelList}>
                    <DataCheck />
                </TabPanel>
            </TabContext>
        </Box>
    );
};
/** TODO
 * 1. Make a common component for tabs
 * 2. Datacheck to be separate component.
 *     Audits gets created from here with file uploads
 */
